
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { uniqueId } from 'lodash'

export default {
  name: 'Toggle',

  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: ''
    },

    type: {
      type: String,
      default: 'toggle',
      validator: prop => ['checkbox', 'radio', 'toggle'].includes(prop)
    },

    name: {
      type: String,
      default: null
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    trueValue: {
      type: [String, Number, Boolean, Object, Array],
      default: true
    },

    falseValue: {
      type: [String, Number, Boolean, Object, Array],
      default: false
    },

    hasLongLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id: null,
      faCheck,
      faTimes
    }
  },

  computed: {
    compValue: {
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    },

    compIsRadio() {
      return this.type === 'radio'
    },

    compIsToggle() {
      return this.type === 'toggle'
    },

    compIsActive() {
      return this.value === this.trueValue
    },

    compType() {
      // A toggle is a checkbox
      return this.type === 'toggle' ? 'checkbox' : this.type
    },

    compClass() {
      return {
        [this.type]: true,
        active: this.value === this.trueValue,
        disabled: this.isDisabled
      }
    }
  },

  created() {
    // Unique ID has to be generated on mounted otherwise it will be different when hydrated vs SSR
    this.id = uniqueId('toggle-')
  }
}
